import { on } from 'delegated-events'

const initIntervalToggle = container => {
  const tabContent = container.querySelector('.interval-toggle-content')
  const toggleCheckbox = container.querySelector('.toggle__checkbox')
  const tabs = container.querySelectorAll('ul.interval-toggle-switch > li')

  on('click', 'ul.interval-toggle-switch > li', event => {
    selectToggle({ container, tab: event.currentTarget })
  })

  if (toggleCheckbox) {
    const current = tabContent?.getAttribute('data-display')
    toggleCheckbox.checked = current === 'annual'

    toggleCheckbox.addEventListener('click', () => {
      setTimeout(() => {
        const isChecked = toggleCheckbox.checked
        const value = isChecked ? 'annual' : 'monthly'

        tabContent?.setAttribute('data-display', value)

        const targetTab = Array.from(tabs).find(
          tab => tab.dataset.for === value
        )
        if (targetTab) {
          selectToggle({ container, tab: targetTab })
        }
      }, 0)
    })
  }
}

const selectToggle = ({ container, tab }) => {
  const tabs = container.querySelectorAll('ul.interval-toggle-switch > li')
  const tabContent = container.querySelectorAll('.interval-toggle-content')[0]
  const toggleCheckbox = container.querySelector('.toggle__checkbox')

  tabs.forEach(tab => tab.classList.remove('active'))
  tab.classList.add('active')
  tabContent.setAttribute('data-display', tab.getAttribute('data-for'))

  if (toggleCheckbox) {
    toggleCheckbox.checked = tab.getAttribute('data-for') === 'annual'
  }
}

const getActiveToggle = container =>
  container.querySelector('ul.interval-toggle-switch > li.active')

export { initIntervalToggle, selectToggle, getActiveToggle }
